import { render, staticRenderFns } from "./EventsSlider.vue?vue&type=template&id=6c00b630&scoped=true&"
import script from "./EventsSlider.vue?vue&type=script&lang=js&"
export * from "./EventsSlider.vue?vue&type=script&lang=js&"
import style0 from "./EventsSlider.vue?vue&type=style&index=0&id=6c00b630&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00b630",
  null
  
)

export default component.exports